// extracted by mini-css-extract-plugin
module.exports = {"trigger":"styles_trigger__2NooT","content":"styles_content__2kSA8","contentShow":"styles_contentShow__3vQq6","closeButton":"styles_closeButton__3V6nb"};